import React, { useEffect } from 'react';
import { IconGear } from './icons/MultiAssetIcons';
import walletLogo from '../assets/wallet.jpg';
import HyperliquidWalletPanel from './HyperliquidWalletPanel';
import './WalletGearModal.css';

export function PageGearButton({ onClick, label = 'Wallet settings', icon = 'gear', showLabel = false }) {
  return (
    <button
      type="button"
      className={`page-gear-btn${showLabel ? ' page-gear-btn-labeled' : ''}`}
      onClick={onClick}
      title={label}
      aria-label={label}
    >
      {icon === 'wallet' ? (
        <img src={walletLogo} alt="" className="page-gear-wallet-img" />
      ) : (
        <IconGear size={22} />
      )}
      {showLabel ? <span className="page-gear-btn-label">{label}</span> : null}
    </button>
  );
}
export default function WalletGearModal({ open, onClose, title, view, compact, apiPrefix = 'multi-asset' }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="wallet-gear-overlay" role="presentation" onClick={onClose}>
      <div
        className="wallet-gear-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="wallet-gear-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="wallet-gear-dialog-header">
          <h2 id="wallet-gear-title">{title}</h2>
          <button type="button" className="wallet-gear-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>
        <div className="wallet-gear-dialog-body">
          <HyperliquidWalletPanel view={view} compact={compact} inModal apiPrefix={apiPrefix} />
        </div>
      </div>
    </div>
  );
}
